var CandidateAdditionalDetails = /** @class */ (function () {
    function CandidateAdditionalDetails() {
        this.candidateId = null;
        this.salary = null;
        this.sponsorships = [];
        this.sponsorshipsNote = null;
        this.willingToRelocate = null;
        this.relocationNote = null;
        this.additionalInformation = null;
        this.workLocations = null;
    }
    return CandidateAdditionalDetails;
}());
export { CandidateAdditionalDetails };
//# sourceMappingURL=candidateAdditionalDetails.js.map